// extracted by mini-css-extract-plugin
module.exports = {"root":"upload-dropzone_root__1ZivW","msg":"upload-dropzone_msg__1cokk"};